module.exports = __webpack_public_path__ + "static/media/paper5.9e98cdcb.png";